import { CircleAlert, MailIcon, TriangleAlert } from "lucide-react";
import { useState } from "react";

import type { Contract } from "@/types/contract";

import { formatCurrency } from "@/lib/utils";
import { DialogDescription, DialogTitle, DialogTrigger } from "@radix-ui/react-dialog";

import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { DialogFooter, DialogHeader } from "../ui/dialog";

export function ReviewComponent({ contract, handleNext }: { contract: Contract; handleNext: () => void }) {
	const [showWarning, setShowWarning] = useState(false);
	return (
		<>
			<DialogHeader className="flex-row items-start justify-between space-y-0">
				{!showWarning && <DialogTitle>Review items</DialogTitle>}
				<DialogTitle className="sr-only">Review items in contract</DialogTitle>
				<DialogDescription className="sr-only">Contract Review</DialogDescription>
			</DialogHeader>
			{showWarning && (
				<>
					<div className="mx-auto size-20 rounded-full p-2  bg-hover-secondary grid place-content-center" role="alert">
						<TriangleAlert className="size-10 text-primary font-light" />
					</div>
					<p className="text-center p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg" role="alert">
						Please review items within your contract carefully before proceeding with your purchase
					</p>
				</>
			)}
			{!showWarning && (
				<div className="max-h-96 overflow-y-auto space-y-2">
					{contract.contractItem.map(item => (
						<Card key={item.id} className="flex flex-wrap shadow-none items-center">
							<CardHeader className="p-2">
								<div className="size-24">
									<img
										src={item.productId.photos[0] ?? "/placeholder.svg"}
										alt={item.productId.name}
										className="object-cover w-full h-full rounded-lg"
									/>
								</div>
							</CardHeader>
							<CardContent className="flex flex-col h-full p-0 justify-center">
								<CardTitle className="capitalize">{item.productId.name}</CardTitle>
								<p>
									Price:
									{formatCurrency(Number(item.productId.price), "NGN")}
								</p>
							</CardContent>
						</Card>
					))}
				</div>
			)}
			<DialogDescription className="text-xs flex items-center gap-2">
				<CircleAlert className="size-4" />
				Please complete payment for these items within 24hours
			</DialogDescription>
			<DialogDescription className="text-xs flex items-center gap-2">
				<MailIcon className="size-4" />
				We will follow up with a confirmation email once payment is complete.
			</DialogDescription>
			<DialogFooter className="sm:justify-between">
				<DialogTrigger asChild>
					<Button variant="secondary">Back</Button>
				</DialogTrigger>
				<Button onClick={() => showWarning ? handleNext() : setShowWarning(true)}>
					Continue
				</Button>
			</DialogFooter>

		</>
	);
}
